export default "images/single room.jpg";